import Vue from 'vue'
import App from './App.vue'
import VueRouter from "vue-router";
import vuetify from './plugins/vuetify';
import Login from "./components/user/Login";
import store from './store'
import Profile from "./components/user/Profile";
import FriendList from "./components/games/FriendList";
import FrontPage from "./components/games/FrontPage";
import Register from "./components/user/Register";
import SingleGame from "./components/games/SingleGame";
import GameList from "./components/admin/GameList";
import GenreList from "./components/admin/GenreList";
import PublisherList from "./components/admin/PublisherList";
import AddGame from "./components/admin/AddGame";
import AddGenre from "./components/admin/AddGenre";
import AddPublisher from "./components/admin/AddPublisher";
import AllGamesList from "./components/games/AllGamesList";
import AllUserList from "./components/user/AllUserList";
import Impressum from "./components/user/Impressum";
import ResetPassword from "@/components/user/ResetPassword";
import ForgotPassword from "@/components/user/ForgotPassword";
import GameTranslations from "@/components/admin/GameTranslations";
import GamesPage from "@/components/games/GamesPage.vue";


Vue.config.productionTip = false;

const routes =
    [
        {
            path: "/",
            component: FrontPage
        },
        {
            path: "/games",
            component: GamesPage
        },
        {
            path: "/game/:slug",
            name: "game",
            component: SingleGame
        },
        {
            path: "/:type/:id/games",
            name: "allGames",
            component: AllGamesList
        },
        {
            path: "/friends",
            component: FriendList
        },
        {
            path: "/login",
            component: Login
        },
        {
            path: "/signup",
            component: Register
        },
        {
            path: "/password/reset",
            component: ResetPassword
        },
        {
            path: "/password/forgot",
            component: ForgotPassword
        },
        {
            path: "/profile",
            component: Profile
        },
        {
            path: "/imprint",
            name: "imprint",
            component: Impressum
        },
        {
            path: "/user/:id",
            name: "user",
            component: Profile
        },
        {
            path: "/users",
            name: "users",
            component: AllUserList

        },
        {
            path: "/admin",
            component: GameList
        },
        {
            path: "/admin/games",
            component: GameList
        },
        {
            path: "/admin/games/add",
            component: AddGame
        },
        {
            path: "/admin/games/edit/:slug",
            name: "editGame",
            component: AddGame
        },
        {
            path: "/admin/translations",
            component: GameTranslations
        },
        {
            path: "/admin/genres",
            component: GenreList
        },

        {
            path: "/admin/genres/add",
            component: AddGenre
        },
        {
            path: "/admin/genres/edit/:id",
            name: "editGenre",
            component: AddGenre
        },
        {
            path: "/admin/publisher",
            component: PublisherList
        },
        {
            path: "/admin/publisher/edit/:id",
            name: "editPublisher",
            component: AddPublisher
        },
        {
            path: "/admin/publisher/add",
            component: AddPublisher
        }
    ];

const router = new VueRouter({
    routes
});

new Vue({
    render: h => h(App),
    vuetify,
    router,
    store
}).$mount('#app')
